import React from "react";
import SignUpTutorial from "./SignUpTutorial";

const DEFAULT_PAGE_TITLES: React.ReactNode[] = [
  <>
    Welcome to Psych for Life<sup>®</sup>!
  </>,
  "Learn Quickly",
  "Apply What You've Learned",
  "Select and Customize",
  "Use!",
];

interface HowItWorksSectionProps {
  title?: React.ReactNode;
  pageTitles?: React.ReactNode[];
}

const HowItWorksSection = ({
  title = "How It Works",
  pageTitles = DEFAULT_PAGE_TITLES,
}: HowItWorksSectionProps) => {
  return (
    <div className="py-20">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-5xl font-bold text-electrum text-center mb-16">
          {title}
        </h2>

        <div className="text-center mb-12">
          <p className="text-3xl text-gray-800">
            Learn. Apply. Customize. Use!
          </p>
        </div>

        <div className="mb-16 max-w-2xl mx-auto">
          <SignUpTutorial pageTitles={pageTitles} />
        </div>
      </div>
    </div>
  );
};

export default HowItWorksSection;
